import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { QueryBarItemImage } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { useWebsitesFavicons } from "app/services/sitesService/hooks/useWebsitesFavicons";

const { carbon, sky, black } = colorsPalettes;
const AUTOMATION_ID = "publisher-analysis-query-bar-header";

const DEMO_FAVICON_URLS = ["foxnews.com", "cnn.com", "usatoday.com"];

const QueryBarItemImageStyled = styled(QueryBarItemImage)`
    margin-right: -8px;
`;

const FaviconsContainer = styled(Flex)`
    margin-left: 24px;
`;

export const PublisherAnalysisQueryBarHeader = () => {
    const { data: favicons = {} } = useWebsitesFavicons(DEMO_FAVICON_URLS, undefined, {
        staleTime: Infinity,
        gcTime: Infinity,
    });

    return (
        <Flex
            margin="8px"
            paddingX="16px"
            paddingY="16px"
            background={sky["100"]}
            borderRadius="3px"
            data-automation={AUTOMATION_ID}
        >
            <Stack gap="8px">
                <Flex gap="8px">
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                        iconColor={carbon["500"]}
                    />
                    <Text
                        fontVariant="subtitle2"
                        color={carbon["500"]}
                    >
                        {translate("publisher-analysis.query-bar.header.title")}
                    </Text>
                </Flex>
                <FaviconsContainer>
                    {DEMO_FAVICON_URLS.map((domain) => (
                        <QueryBarItemImageStyled
                            margin="0"
                            image={favicons?.[domain]}
                            borderColor={carbon["50"]}
                        />
                    ))}
                    <QueryBarItemImageStyled
                        margin="0"
                        image={""}
                        borderColor={carbon["50"]}
                        renderImage={() => (
                            <Text
                                fontVariant="queryBar1"
                                color={black[0]}
                            >
                                {translate("publisher-analysis.query-bar.header.more")}
                            </Text>
                        )}
                    />
                </FaviconsContainer>
            </Stack>
        </Flex>
    );
};
